import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';

@Component({
    //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover.component.html',
    template: require('./new-year-rollover.component.html'),
    directives: [ROUTER_DIRECTIVES],
    providers:[]
    
})

export class NewYearRolloverComponent implements OnInit, OnDestroy{
    pageTitle: string = 'New Year Rollover';
    errorMessage: string;
   
    constructor(private route: ActivatedRoute,
                private router: Router) {
                    
    }

    ngOnInit(): void{
       
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/new-year-rollover/new-year-rollover.component.ts
 **/